import React, { useState, useEffect } from "react";
import {
  Container, Card, ButtonGroup, Button, OverlayTrigger,
  Tooltip
} from "react-bootstrap";
import {
  product, productRow, productCard, productBody, productImg,
  productTitle, productColorBtn, shopBtn, titleLink, second,
  productPrice, wTitle, btnActive, productCardContainer, alternateVariantWidth, alternateVariantHeight
} from "./style.mod.scss";
import Link from "components/link";
import { Swiper, SwiperSlide } from "swiper/react";
import locale from "locales";
import ArrowRight from "assets/svgs/arrow-right.svg";
import getImagePath from "helpers/get-image-path";

const collectionProduct = ({ data }) => {
  const [variants, setVariants] = useState(data.products?.map(e => e.variants[0]));
  const collectionsLoc = locale.collections;


  const { products } = data;
  useEffect(() => {
    setVariants(data.products.map(e => e.variants[0]));
  }, [data]);

  var settings = {
    pagination: { clickable: true },
    navigation: { clickable: true },
    clickable: false,
    slidesPerView: data.products.length === 1 ? 1 : 1.5,
    spaceBetween: 15,
    breakpoints: {
      767: {
        slidesPerColumnFill: "row",
        slidesPerView: 3,
        spaceBetween: 30,
        pagination: { clickable: true },
      },
      1024: {
        slidesPerColumnFill: "row",
        slidesPerView: 3,
        slidesPerColumn: 2,
        slidesPerGroup: 3,
        spaceBetween: 30,
        allowTouchMove: false,
      }
    },
  };

  const handleVariantSelect = (index, v) => {
    setVariants(old => {
      const nw = [...old];
      nw[index] = v;
      return nw;
    });
  };


  return (
    <div className={product}>
      <Container>
        <h2 className={wTitle}>{data.collectionTitle}</h2>
        <Swiper
          {...settings}
          className={productRow}
          beforeChange={() => document.activeElement.blur()}
        >
          {products.map((k, index) => (
            <SwiperSlide key={index}>
              <div className={productCardContainer} key={index}>
                <Card className={productCard}>
                  <Link to={variants[index]?.link}>
                    <Card.Img
                      className={productImg}
                      variant="top"
                      src={getImagePath(variants[index]?.variantImage)}
                      alt={variants[index]?.variantImage?.alt}
                    />
                  </Link>
                  <Card.Body className={productBody}>
                    <Card.Title className={productTitle}>
                      <Link to={variants[index]?.link} className={titleLink}>
                        <h3>{variants[index]?.title}</h3>
                      </Link>
                      {data.alternatingDetails ? (
                        <p className={`${productPrice} ${second}`}>
                          &euro;{variants[index]?.price}
                        </p>
                      ) : (
                        <ButtonGroup>
                          {k.variants.map(v => {
                            return (
                              k.variants.length > 1 && (
                                <OverlayTrigger
                                  key={v._key}
                                  placement="bottom"
                                  overlay={
                                    <Tooltip id="bottom">{v.colorName}</Tooltip>
                                  }
                                >
                                  <Button
                                    variant="secondary"
                                    className={`${productColorBtn} ${v === variants[index] ? btnActive : ""
                                      }`}
                                    onClick={() =>
                                      handleVariantSelect(index, v)
                                    }
                                    active={v === variants[index]}
                                    style={{
                                      backgroundColor: `${v.variantColor}`,
                                      backgroundImage: `url("${v.variantBackground}")`,
                                      backgroundSize: "cover",
                                    }}
                                  ></Button>
                                </OverlayTrigger>
                              )
                            );
                          })}
                        </ButtonGroup>
                      )}
                    </Card.Title>
                    {data.alternatingDetails ? (
                      <ButtonGroup
                        className={
                          data.products.length === 1
                            ? `${alternateVariantHeight}`
                            : `${alternateVariantWidth}`
                        }
                      >
                        {k.variants.map(v => {
                          return (
                            k.variants.length > 1 && (
                              <OverlayTrigger
                                key={v._key}
                                placement="bottom"
                                overlay={
                                  <Tooltip id="bottom">{v.colorName}</Tooltip>
                                }
                              >
                                <Button
                                  variant="secondary"
                                  className={`${productColorBtn} ${v === variants[index] ? btnActive : ""
                                    }`}
                                  onClick={() => handleVariantSelect(index, v)}
                                  active={v === variants[index]}
                                  style={{
                                    backgroundColor: `${v.variantColor}`,
                                    backgroundImage: `url("${v.variantBackground}")`,
                                    backgroundSize: "cover",
                                  }}
                                ></Button>
                              </OverlayTrigger>
                            )
                          );
                        })
                        }
                      </ButtonGroup>
                    ) : (
                      <p className={productPrice}>
                          &euro;{variants[index]?.price} 
                        {variants[index].compareAtPrice && <span>&euro;{variants[index].compareAtPrice}</span>}
                      </p>
                    )}
                    {/* <Card.Text>
                  </Card.Text> */}
                    <Link to={variants[index]?.link}>
                      <button className={shopBtn}>
                        <span>
                          {collectionsLoc.shopInValentinesDay}
                        </span>
                        <ArrowRight />
                      </button>
                    </Link>
                  </Card.Body>
                </Card>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </div>
  );
};

export default collectionProduct;
